<script lang="ts">
  import {  Card, Col, Image, Row } from "sveltestrap";
  import UserFollowers from "../Users/UserProfile/UserFollowers.svelte";
  import UserPhotos from "../Users/UserProfile/UserPhotos.svelte";
  import UserFriends from "../Users/UserProfile/UserFriends.svelte";
  import ProfileInfo from "./ProfileInfo.svelte";
  let imgPath:string = "/assets/images/social-app"
</script>
<Col xl="3" class="xl-100 box-col-12">
    <div class="default-according style-1 faq-accordion job-accordion" >
      <Row>
        <ProfileInfo />
        <UserFollowers />
        <UserPhotos />
        <UserFriends />
        <Col xl="12" class="xl-50 box-col-6">
          <Card>
            <Image fluid src="{imgPath}/timeline-4.png" />
          </Card>
        </Col>
      </Row>
    </div>
</Col>